import React from 'react';
import { waLink } from '../lib/whatsapp';

export default function WhatsAppFloat({ message }) {
  return (
    <a
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float"
      aria-label="WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <i className="fa-brands fa-whatsapp"></i>
    </a>
  );
}
